import { DateOnly } from '@sevenrooms/timepiece'
import type { UserPreference, UserSignificantDate } from '@sevenrooms/ui-kit/core'

export function mapPreferencesToTags(preferences: UserPreference[], dietaryPreferenceTags: Record<string, string>) {
  const keys = Object.keys(dietaryPreferenceTags)
  return preferences
    .map(({ preferenceValue }) => keys.find(key => key.endsWith(`##${preferenceValue}`)))
    .filter((k): k is string => k !== undefined)
}

function adjustToDateString(value: number) {
  if (value < 10) {
    return `0${value}`
  }
  return `${value}`
}

export const getBirthdayParts = (significantDates?: UserSignificantDate[]) => {
  const birthdayString = significantDates?.find(date => date.dateType === 'birthday')?.dateUtc
  const dateOnly = DateOnly.fromSafe(birthdayString)
  if (!dateOnly) {
    return [undefined, undefined]
  }
  const month = dateOnly.toJsDate().getMonth() + 1
  const day = dateOnly.toJsDate().getDate()
  return [adjustToDateString(month), adjustToDateString(day)]
}
